import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { AppState } from 'store/store';
import { IResTimeslotsBranch } from 'api/services/timeslotsBranches/types';
import cn from 'classnames';

import './TimeslotsBranchesList.sass';

interface Props {
  timeslotsItems: IResTimeslotsBranch[];
  loading: boolean;
}

export const TimeslotsBranchesList: React.FC<Props> = ({
  timeslotsItems,
  loading,
}) => {
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.components.queueList
  );

  return (
    <div className={'timeslots-branches-list'}>
      {timeslotsItems
        ?.sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt))
        .map((i) => (
          <div
            className={cn('timeslots-branches-list__item', {
              'timeslots-branches-list__item--loading': loading,
            })}
            key={i.id}
          >
            <Typography
              variant='h3'
              className='timeslots-branches-list__item-code'
            >
              {i.application?.pass?.match(/.{3}/g)?.join(' ') || ''}
            </Typography>
            <Typography
              variant='h5'
              className='timeslots-branches-list__item-name'
            >
              {`${i.application?.user.lastName} ${
                i.application?.user.firstName?.charAt(0) || ''
              }. ${i.application?.user.middleName?.charAt(0) || ''}.`}
            </Typography>
          </div>
        ))}
    </div>
  );
};
